// extracted by mini-css-extract-plugin
export default {"icon-button":"style_icon-button__HmEEt","icon-button-detailpage":"style_icon-button-detailpage__75VE3"};